import { motion } from "framer-motion";
import { MapPin, Gauge, Calendar, TrendingUp } from "lucide-react";
import { PROJECTS } from "@/lib/sipl-content";

export default function Projects() {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="section-y bg-sipl-primary text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none [background-image:radial-gradient(white_1px,transparent_1px)] [background-size:18px_18px]" />
      <div className="container-x relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-sm uppercase tracking-[0.22em] text-sipl-accent mb-4 dash-accent">
              Projects & Case Studies
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white font-semibold tracking-tight leading-[1.08]">
              Real deployments. Measurable impact.
            </h2>
          </div>
          <p className="text-white/70 max-w-md">
            A snapshot of work delivered for ULBs, public-sector enterprises and
            community-anchored utilities across India.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {PROJECTS.map((p, idx) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: idx * 0.07 }}
              data-testid={`project-card-${p.id}`}
              className="bg-white/5 border border-white/10 rounded-lg overflow-hidden hover:bg-white/10 hover:border-sipl-accent/40 transition-all duration-300 flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>
              <div className="p-5 flex flex-col gap-3 flex-1">
                <div className="text-[10px] uppercase tracking-[0.22em] text-sipl-accent">
                  {p.tag}
                </div>
                <h3 className="font-heading text-lg font-medium leading-snug">
                  {p.title}
                </h3>
                <ul className="mt-1 space-y-2 text-sm text-white/80">
                  <li className="flex items-start gap-2">
                    <MapPin className="w-4 h-4 mt-0.5 text-sipl-accent shrink-0" />
                    <span>{p.location}</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Gauge className="w-4 h-4 mt-0.5 text-sipl-accent shrink-0" />
                    <span>{p.capacity}</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Calendar className="w-4 h-4 mt-0.5 text-sipl-accent shrink-0" />
                    <span>{p.duration}</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <TrendingUp className="w-4 h-4 mt-0.5 text-sipl-accent shrink-0" />
                    <span>{p.impact}</span>
                  </li>
                </ul>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
